module.exports = __webpack_public_path__ + "img/IMG_9000_L_Black.fd4f7f78.jpg";